export default "__VITE_ASSET__04e8d2ac__"